export const DATE_FORMATE_FOR_UI = "MM/DD/YYYY";